import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import FileInfoBlock from "./FileInfoBlock";
import FileListBox from "./FileListBox";
import "./index.scss";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faHamburger,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Treebeard } from "react-treebeard";
import decorators from "react-treebeard/dist/components/Decorators";
import defaultTheme from "react-treebeard/dist/themes/default";
import NoRecord from "../../../components/common/NoRecord";
import LoaderUI from "../../../components/common/loader";
import ReactTooltip from "react-tooltip";
import ReadOnly from "./ReadOnly";
import EditReadOnlyPermission from "./EditReadOnlyPermission";

const FilesInfoWrappper = ({
  dropdownData,
  onToggle,
  documentDetail,
  onClickEvent,
  list,
  refreshFiles,
  resetType,
  getUnableToValidate,
  selectedQuery,
  __editDocument,
  __editUnlabeledDocument,
  getOtherDocuments,
  loader,
  favUnfavDoc,
  fileStatus,
  selectedIconId,
  handleDocSelection,
  selectedDocument,
  fileRefreshFlag,
  getArchiveDocuments,
  getDocInNeedOfReview,
  otherDocs,
  labeledData,
  reviewRequestedPageHandle,
  otherDocsPageHandle,
  labeledPageHandle,
  reviewRequestedPage,
  otherDocsPage,
  reviewRequestedCount,
  otherDocsCount,
  labeledDocsPage,
  reviewRequestedData,
  otherDocsData,
  otherLabeledDocsData,
  isReviewRequestLoading,
  isOtherDocsLoading,
  isLabeledDataLoading,
  otherLabeledDocsPageHandle,
  otherLabeledDocsPage,
  typeSelected,
  setTypeSelected,
  typeSelectedGrandParent, 
  setTypeSelectedGrandParent,
  typeSelectedParent,
  setTypeSelectedParent,
  typeSelectedChild,
  setTypeSelectedChild
}) => {
  const [documentInfo, setDocumentInfo] = useState({});
  
  useEffect(() => {
    setDocumentInfo(
      reviewRequestedData?.docs?.length > 0
        ? reviewRequestedData?.docs[0]
        : labeledData?.length > 0 && labeledData[0]?.docs?.length > 0 
          ? labeledData[0]?.docs[0] 
          : otherDocs?.docs?.length > 0 
            ? otherDocs?.docs[0] 
            : {}
    );
  }, [reviewRequestedData?.docs, otherDocs, labeledData]);

  // const [typeSelected, setTypeSelected] = useState("");
  // const [typeSelectedGrandParent, setTypeSelectedGrandParent] = useState("");
  // const [typeSelectedParent, setTypeSelectedParent] = useState("");
  // const [typeSelectedChild, setTypeSelectedChild] = useState("");
  const [reviewRequestedStartingIndex, setReviewRequestedStartingIndex] =
    useState(1);
  const [reviewRequestedEndingIndex, setReviewRequestedEndingIndex] =
    useState();

  const [otherDocsStartingIndex, setOtherDocsStartingIndex] = useState(1);
  const [otherDocsEndingIndex, setOtherDocsEndingIndex] = useState();
  const [otherLabeledDocsStartingIndex, setOtherLabeledDocsStartingIndex] =
    useState(1);
  const [otherLabeledDocsEndingIndex, setOtherLabeledDocsEndingIndex] =
    useState();
  const [noRecords, setNoRecords] = useState(false);

  const userDetail = useSelector((state) => state?.user?.user);

  // Use Effect to initially define the end range of review requested and other docs
  useEffect(() => {
    if (!reviewRequestedData?.hasNextPage) {
      setReviewRequestedEndingIndex(reviewRequestedCount);
    } else {
      setReviewRequestedEndingIndex(10);
    }

    if (!otherDocsData?.hasNextPage) {
      setOtherDocsEndingIndex(otherDocsData?.totalDocs);
    } else {
      setOtherDocsEndingIndex(10);
    }

    if (!otherLabeledDocsData?.hasNextPage) {
      setOtherLabeledDocsEndingIndex(otherDocsData?.totalDocs);
    } else {
      setOtherLabeledDocsEndingIndex(10);
    }
  }, [
    list,
    reviewRequestedData?.hasNextPage,
    otherDocsData?.hasNextPage,
    otherLabeledDocsData?.hasNextPage,
  ]);

  useEffect(() => {
    if (reviewRequestedData?.page == 1) {
      setReviewRequestedStartingIndex(1);
    }
  }, [reviewRequestedData]);

  useEffect(() => {
    if (otherDocsData?.page == 1) {
      setOtherDocsStartingIndex(1);
    }
  }, [otherDocsData]);

  // use effect to check no records or not
  useEffect(() => {
    if (labeledData != undefined || labeledData?.length != 0) {
      if (
        reviewRequestedData?.totalDocs == 0 &&
        otherDocs?.length == 0 &&
        (labeledData?.length == 0 ||
          labeledData?.reduce((sum, obj) => sum + obj.totalDocs, 0) === 0)
      ) {
        setNoRecords(true);
      } else {
        setNoRecords(false);
      }
    } else {
      if (reviewRequestedData?.totalDocs == 0 && otherDocs.length == 0) {
        setNoRecords(true);
      } else {
        setNoRecords(false);
      }
    }
  }, [reviewRequestedData, otherDocsData, labeledData]);

  // Calculate Range For document showing in review requested
  function calculateReviewRequestedRange(pageNumber, paginationLimit) {
    const startingIndex = (pageNumber - 1) * paginationLimit + 1;
    const endingIndex = pageNumber * paginationLimit;

    setReviewRequestedStartingIndex(startingIndex);

    if (!reviewRequestedData?.hasNextPage) {
      setReviewRequestedEndingIndex(reviewRequestedCount);
    } else {
      setReviewRequestedEndingIndex(endingIndex);
    }
  }

  // Calculate Range For document showing in labeled Documents
  function calculateLabeledDocsRange(pageNumber, paginationLimit) {
    const startingIndex = (pageNumber - 1) * paginationLimit + 1;
    const endingIndex = pageNumber * paginationLimit;

    setOtherDocsStartingIndex(startingIndex);

    if (!otherDocsData?.hasNextPage) {
      setOtherDocsEndingIndex(otherDocsCount);
    } else {
      setOtherDocsEndingIndex(endingIndex);
    }
  }

  // Calculate Range For document showing in other documents
  function calculateOtherDocsRange(pageNumber, paginationLimit) {
    const startingIndex = (pageNumber - 1) * paginationLimit + 1;
    const endingIndex = pageNumber * paginationLimit;

    setOtherDocsStartingIndex(startingIndex);

    if (!otherDocsData?.hasNextPage) {
      setOtherDocsEndingIndex(list?.other_documents?.docs?.length);
    } else {
      setOtherDocsEndingIndex(endingIndex);
    }
  }

  // Calculate Range For document showing in other documents
  function calculateOtherLabeledDocsRange(pageNumber, paginationLimit) {
    const startingIndex = (pageNumber - 1) * paginationLimit + 1;
    const endingIndex = pageNumber * paginationLimit;

    setOtherLabeledDocsStartingIndex(startingIndex);

    if (!otherLabeledDocsData?.hasNextPage) {
      setOtherLabeledDocsEndingIndex(otherLabeledDocsData?.docs?.length);
    } else {
      setOtherLabeledDocsEndingIndex(endingIndex);
    }
  }

  // Handle Pagination of Review Requested section
  const _reviewRequestedPageHandle = (page) => {
    reviewRequestedPageHandle(page);
    calculateReviewRequestedRange(page, 10);
  };

  // Handle Pagination of Other Documents section
  const _otherDocsPageHandle = (page) => {
    otherDocsPageHandle(page);
    calculateOtherDocsRange(page, 10);
  };

  // Handle Pagination of Other Documents section
  const _otherLabeledDocsPageHandle = (page) => {
    otherLabeledDocsPageHandle(page);
    calculateOtherLabeledDocsRange(page, 10);
  };

  const _labeledPageHandle = (page, type, parentName) => {
    labeledPageHandle(page, type, parentName);
    calculateLabeledDocsRange(page, 10);
  };

  const [fileStack, setFileStack] = useState(false);
  if (typeSelected) {
  }

  const toggleSidebar = () => {
    setFileStack(!fileStack);
  };

  const _favUnfavDoc = (favorite, id, doc, type) => {
    setDocumentInfo(doc);
    favUnfavDoc(favorite, id, doc, type);
  };

  // const CustomHeader = (props) => {
  //   return (
  //     <div
  //       className={` ${
  //         !props.node.children &&
  //         (props.node._id == typeSelected ? "active" : "")
  //       } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
  //     >
  //       {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
  //     </div>
  //   );
  // };

  const findParentAndGrandparent = (
    objectsArray,
    targetId,
    currentLevel = 0,
    parent = null,
    grandparent = null
  ) => {
    for (const obj of objectsArray) {
      if (obj._id === targetId) {
        return {
          parent: parent ? parent.name : null,
          grandparent: grandparent ? grandparent.name : null,
        };
      }

      if (obj.children) {
        const parentObject = currentLevel === 1 ? obj : parent;
        const grandparentObject = currentLevel === 0 ? obj : grandparent;

        const result = findParentAndGrandparent(
          obj.children,
          targetId,
          currentLevel + 1,
          parentObject,
          grandparentObject
        );
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  const _resetType = () => {
    setReviewRequestedStartingIndex(1);
    setOtherDocsStartingIndex(1);
    setOtherLabeledDocsStartingIndex(1)
    setTypeSelected("");
    setTypeSelectedChild("");
    setTypeSelectedParent("");
    setTypeSelectedGrandParent("");
    resetType();
  };

  const _getUnableToValidate = () => {
    setReviewRequestedStartingIndex(1);
    setOtherDocsStartingIndex(1);
    setOtherLabeledDocsStartingIndex(1)
    setTypeSelected("");
    setTypeSelectedChild("");
    setTypeSelectedParent("");
    setTypeSelectedGrandParent("");
    getUnableToValidate();
  };

  const _getOtherDocuments = () => {
    setReviewRequestedStartingIndex(1);
    setOtherDocsStartingIndex(1);
    setOtherLabeledDocsStartingIndex(1)
    setTypeSelected("");
    setTypeSelectedChild("");
    setTypeSelectedParent("");
    setTypeSelectedGrandParent("");
    getOtherDocuments();
  };

  const _getDocInNeedOfReview = () => {
    setReviewRequestedStartingIndex(1);
    setOtherDocsStartingIndex(1);
    setOtherLabeledDocsStartingIndex(1)
    setTypeSelected("");
    setTypeSelectedChild("");
    setTypeSelectedParent("");
    setTypeSelectedGrandParent("");
    getDocInNeedOfReview();
  };

  const _getArchiveDocuments = () => {
    setReviewRequestedStartingIndex(1);
    setOtherDocsStartingIndex(1);
    setOtherLabeledDocsStartingIndex(1)
    setTypeSelected("");
    setTypeSelectedChild("");
    setTypeSelectedParent("");
    setTypeSelectedGrandParent("");
    getArchiveDocuments();
  };

  const handleDivClick = (value, e) => {
    // Call the function passed from the parent with the value
    switch (e.detail) {
      case 1:
        onClickEvent(value);
        handleDocSelection(value);
        break;
      case 2:
        if (
          !value.deleted &&
          !(value?.type == null && value?.packet_type == null)
        ) {
          __editDocument();
          break;
        } else if (
          !value.deleted &&
          value?.type == null &&
          value?.packet_type == null
        ) {
          __editUnlabeledDocument();
          break;
        }
    }
  };


  
  const _onToggle = (node, toggled) => {
    if (!node?.children) {
      setTypeSelected(node?._id);
      setTypeSelectedChild(node?.name);
      let parents = findParentAndGrandparent(dropdownData?.children, node?._id);
      if (parents) {
        setTypeSelectedParent(parents?.parent);
        setTypeSelectedGrandParent(parents?.grandparent);
      }
    }
    onToggle(node, toggled);
  };

  const [visibleDocs, setVisibleDocs] = useState(100); // Number of initially visible documents
  const [reviewRequestedDocs, setReviewRequestedDocs] = useState(
    list?.review_requested?.docs
      ? list?.review_requested?.docs?.slice(0, visibleDocs)
      : []
  );
  const fileListRef = useRef(null);

  const handleScroll = () => {
    const element = fileListRef.current;

    if (element?.scrollWidth - element?.scrollLeft === element?.clientWidth) {
      // User has scrolled to the bottom
      if (visibleDocs < list?.review_requested?.docs?.length) {
        // Load more documents if available
        let array = [];
        if (visibleDocs + 100 < list?.review_requested?.docs?.length) {
          setReviewRequestedDocs((prevDocs) => [
            ...prevDocs,
            ...list?.review_requested?.docs?.slice(
              visibleDocs,
              visibleDocs + 100
            ),
          ]);
        } else {
          setReviewRequestedDocs((prevDocs) => [
            ...prevDocs,
            ...list?.review_requested?.docs?.slice(
              visibleDocs,
              list?.review_requested?.docs?.length
            ),
          ]);
        }
        setVisibleDocs((prevVisibleDocs) => prevVisibleDocs + 100);
      }
    }
  };

  useEffect(() => {
    setReviewRequestedDocs(list?.review_requested?.docs?.slice(0, visibleDocs));
  }, [list]);



  const customTheme = {
    ...defaultTheme,
    tree: {
      ...defaultTheme.tree,
      node: {
        ...defaultTheme.tree.node,
        activeLink: {
          background: '#f0f0f0' // Changed from 'red' to be less aggressive
        }
      }
    }
  };


  const isLeafNode = (node) => node.item_level == 2;


  
  
  let nodeIndex = 0;
  let backgroundColor = '#f3f2ee';
  const CustomHeader = (props) => {
 
    if (isLeafNode(props.node)) {
      if(nodeIndex == 0){
       backgroundColor = '#f3f2ee';
       nodeIndex = 1;
      }else{
        backgroundColor = '#ffffff';
        nodeIndex = 0;
      }
      if(props.node._id == typeSelected){
        backgroundColor= '';
      }
      return (
        <div
          style={{
            ...props.style,
            backgroundColor,
            width: "100%",
            fontSize: 12,
            fontWeight: 'normal',
            borderRadius: '4px'
          }}
          className={` ${
            !props.node.children &&
            (props.node._id == typeSelected ? "active" : "")
          } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
        >
          {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
        </div>
      );
    }
  
    // For parent nodes
    return (
      <div
        // style={{
        //   ...props.style,
        //   padding: '4px 8px',
        //   fontSize: 12,
        //   fontWeight: 'bold',
        //   backgroundColor: 'transparent'
        // }}
        className={` ${
          !props.node.children &&
          (props.node._id == typeSelected ? "active" : "")
        } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
      >
        {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
      </div>
    );
  };


  const CustomHeader_back = (props) => {
    return (
      <div
        className={` ${
          !props.node.children &&
          (props.node._id == typeSelected ? "active" : "")
        } ${props.node.children?.length ? "sd-header" : "sd-childs"}`}
      >
        {props.node.name} {props.node.count > 0 ? `(${props.node.count})` : ""}
      </div>
    );
  };



  const customDecorators = {
    ...decorators,
    Header: CustomHeader
  };





  return (
    <>
      {loader ? (
        <LoaderUI />
      ) : (
        <div className="files-info-wrapper d-flex overflow-auto">
          {(isReviewRequestLoading ||
            isOtherDocsLoading ||
            isLabeledDataLoading) && <LoaderUI />}
          <div className="left-col">
            <Button
              color="link"
              className="stack-menu-dropdown-btn d-inline-flex align-items-center justify-content-center"
              onClick={toggleSidebar}
              data-tip="Stacking Order"
            >
              <FontAwesomeIcon icon={faBars} />
              <ReactTooltip />
            </Button>
            <div className={`file-stack-block ${fileStack && "active"}`}>
              <div className="head d-flex flex-column">
                <h2 className="mt-auto">Stacking Order</h2>
                {fileRefreshFlag && (
                  <span
                    data-toggle="tooltip"
                    data-placement="top"
                    title="New File"
                    className="new-file-indicator"
                  >
                    <img
                      className="img-fluid"
                      src={require("../../../assets/img/indicator.png")}
                      alt="Indicator"
                    />
                  </span>
                )}
                <Button
                  data-placement="top"
                  title={"Reset"}
                  color="link"
                  className="reset-btn"
                  data-tip="Reset"
                  onClick={_resetType}
                >
                  <FontAwesomeIcon icon={faRedoAlt} />
                  <ReactTooltip />
                </Button>
              </div>
              <div className="file-stack-list label-dropdown-blc position-relative">
                <div className="list-block">
                  {/* <div className="heading refresh-list-hd">
                    <h3>
                      Stacking Order

                    </h3>
                    {fileRefreshFlag && <span data-toggle="tooltip" data-placement="top" title="New File" className="new-file-indicator">
                      <img className="img-fluid" src={require('../../../assets/img/indicator.png')} alt="Indicator" />
                    </span>
                    }
                    <Button
                      data-placement="top"
                      title={"Reset"}
                      color="link"
                      className="reset-btn"
                      data-tip="Reset"
                      onClick={_resetType}
                    >
                      <FontAwesomeIcon icon={faRedoAlt} />
                      <ReactTooltip />
                    </Button>
                  </div> */}
                  <div className="miscellaneous-list">
                    <ul>
                      <li
                        className={`miscellaneous-list-item ${
                          selectedQuery == "doc_in_review" ? "active" : ""
                        }`}
                        style={{ marginLeft: "13px" }}
                        onClick={_getDocInNeedOfReview}
                      >
                        Docs in Need of Review{" "}

                        {reviewRequestedCount ? "(" + reviewRequestedCount + ")" : ""}
                      </li>
                    </ul>

                    <Treebeard
                      data={dropdownData}
                      onToggle={_onToggle}
                      decorators={customDecorators}
                      defaultTheme={customTheme}
                    />
                  </div>
                </div>
                <div className="list-block">
                  <div className="heading">
                    <h3>Miscellaneous</h3>
                  </div>
                  <div className="miscellaneous-list">
                    <ul>
                      <li
                        className={`miscellaneous-list-item ${
                          selectedQuery == "unable_to_validate" ? "active" : ""
                        }`}
                        onClick={_getUnableToValidate}
                      >
                        Unable To Validate{" "}
                        {list?.unable_to_validate_count > 0
                          ? " (" + list?.unable_to_validate_count + ")"
                          : ""}
                      </li>
                      <li
                        className={`miscellaneous-list-item ${
                          selectedQuery == "other_documents" ? "active" : ""
                        }`}
                        onClick={_getOtherDocuments}
                      >
                        Indexed
                        {list?.unlabeledCount > 0
                          ? " (" + list?.unlabeledCount + ")"
                          : ""}
                      </li>
                      <li
                        className={`miscellaneous-list-item ${
                          selectedQuery == "archive" ? "active" : ""
                        }`}
                        onClick={_getArchiveDocuments}
                      >
                        Archive
                        {list?.archieveCount > 0
                          ? " (" + list?.archieveCount + ")"
                          : ""}
                      </li>
                    </ul>
                  </div>

                  <br />
                </div>
              </div>
            </div>
          </div>
          <div className="right-col d-flex flex-column flex-fill overflow-auto">
            <FileInfoBlock
              documentDetail={documentInfo ? documentInfo : {}}
              refreshFiles={() => {
                refreshFiles()
                setOtherDocsStartingIndex(1)
                setReviewRequestedStartingIndex(1)
                setOtherLabeledDocsStartingIndex(1)
              }}
            />
            <div className="file-list-wrapper overflow-auto">
              {reviewRequestedData?.docs?.length > 0 && (
                <div className="file-list-block">
                  <div className="head d-flex align-items-center">
                    Review Requested: {reviewRequestedData?.totalDocs}
                    <div className="current-view-count">
                      Showing {reviewRequestedStartingIndex}-
                      {!reviewRequestedData?.hasNextPage
                        ? reviewRequestedData?.totalDocs
                        : reviewRequestedEndingIndex}{" "}
                      Records out of {reviewRequestedData?.totalDocs}
                    </div>
                  </div>

                  <div
                    className="d-flex position-relative"
                    style={{ minHeight: "185px" }}
                    ref={fileListRef}
                    onScroll={handleScroll}
                  >
                    {reviewRequestedData &&
                      reviewRequestedData?.docs?.length > 0 && (
                        <div className="pagin_cust docu position-absolute review-list-btn left-btn">
                          <div
                            className={`prev ${
                              !reviewRequestedData?.hasPrevPage
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              _reviewRequestedPageHandle(
                                reviewRequestedPage - 1
                              );
                            }}
                          >
                            <div>
                              <i class="fas fa-angle-left"></i>
                            </div>
                          </div>
                        </div>
                      )}
                    {reviewRequestedData &&
                      reviewRequestedData?.docs?.length > 0 && (
                        <div className="pagin_cust docu position-absolute review-list-btn right-btn">
                          <div
                            className={`next  ${
                              !reviewRequestedData?.hasNextPage
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              _reviewRequestedPageHandle(
                                reviewRequestedPage + 1
                              );
                            }}
                          >
                            <div>
                              <i class="fas fa-angle-right"></i>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="file-list-rw d-flex overflow-auto">
                      {reviewRequestedData?.docs?.map((doc) => (
                        <div
                          className="list-col"
                          onClick={(e) => {
                            setDocumentInfo(doc);
                            handleDivClick(doc, e);
                          }}
                        >
                          <FileListBox
                            className={`error ${
                              doc?._id == selectedDocument ? "active" : ""
                            }`}
                            fileStatus={fileStatus}
                            selectedIconId={selectedIconId}
                            handleFavUnfavDoc={(status, id) => {
                              _favUnfavDoc(status, id, doc, "reviewrequested");
                            }}
                            documentDetails={doc}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {labeledData &&
                labeledData[0]?.docs?.length > 0 &&
                labeledData?.map((type) => {
                  return (
                    <div className="file-list-block">
                      <div className="head">
                        <span className="file-category">
                          {typeSelectedChild
                            ? typeSelectedGrandParent +
                              " / " +
                              typeSelectedParent +
                              " / " +
                              typeSelectedChild
                            : type?.mainparentName}
                          : {type?.totalDocs}
                        </span>
                        <div className="current-view-count">
                          Showing {(type?.page - 1) * type?.limit + 1}-
                          {!type?.hasNextPage
                            ? type?.totalDocs
                            : type?.page * type?.limit}{" "}
                          Records out of {type?.totalDocs}
                        </div>
                      </div>

                      <div
                        className="d-flex position-relative"
                        ref={fileListRef}
                        onScroll={handleScroll}
                      >
                        {type?.totalDocs && type?.totalDocs > 0 && (
                          <div className="pagin_cust docu position-absolute review-list-btn left-btn">
                            <div
                              className={`prev ${
                                !type?.hasPrevPage ? "disabled" : ""
                              }`}
                              onClick={() => {
                                _labeledPageHandle(
                                  labeledDocsPage[
                                    type?.docs[0]?.type_mainparent
                                  ]
                                    ? labeledDocsPage[
                                        type?.docs[0]?.type_mainparent
                                      ] - 1
                                    : 1,
                                  type?.docs[0]?.type_mainparent, type?.mainparentName
                                );
                              }}
                            >
                              <div>
                                <i class="fas fa-angle-left"></i>
                              </div>
                            </div>
                          </div>
                        )}
                        {type?.docs && type?.docs?.length > 0 && (
                          <div className="pagin_cust docu position-absolute review-list-btn right-btn">
                            <div
                              className={`next  ${
                                !type?.hasNextPage ? "disabled" : ""
                              }`}
                              onClick={() => {
                                _labeledPageHandle(
                                  labeledDocsPage[
                                    type?.docs[0]?.type_mainparent
                                  ]
                                    ? labeledDocsPage[
                                        type?.docs[0]?.type_mainparent
                                      ] + 1
                                    : 2,
                                  type?.docs[0]?.type_mainparent, type?.mainparentName
                                );
                              }}
                            >
                              <div>
                                <i class="fas fa-angle-right"></i>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="file-list-rw d-flex overflow-auto">
                          {type?.docs?.map((doc) => {
                            return (
                              <div
                                className="list-col"
                                onClick={(e) => {
                                  setDocumentInfo(doc);
                                  handleDivClick(doc, e);
                                }}
                              >
                                <FileListBox
                                  className={`success ${
                                    doc?._id == selectedDocument ? "active" : ""
                                  }`}
                                  fileStatus={fileStatus}
                                  selectedIconId={selectedIconId}
                                  handleFavUnfavDoc={(status, id) => {
                                    _favUnfavDoc(
                                      status,
                                      id,
                                      doc,
                                      "labeleddata"
                                    );
                                  }}
                                  documentDetails={doc}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}

              {otherDocs?.length > 0 && (
                <div className="file-list-block">
                  <div className="head d-flex align-items-center">
                    Unlabeled Documents:{"  "}
                    {otherDocsData?.totalDocs}
                    <div className="current-view-count">
                      Showing {otherDocsStartingIndex}-
                      {!otherDocsData?.hasNextPage
                        ? otherDocsData?.totalDocs
                        : otherDocsEndingIndex}{" "}
                      Records out of {otherDocsData?.totalDocs}
                    </div>
                  </div>

                  <div
                    className="d-flex position-relative"
                    ref={fileListRef}
                    onScroll={handleScroll}
                  >
                    {otherDocs && otherDocs.length > 0 && (
                      <div className="pagin_cust docu position-absolute review-list-btn left-btn">
                        <div
                          className={`prev ${
                            !otherDocsData?.hasPrevPage ? "disabled" : ""
                          }`}
                          onClick={() => {
                            _otherDocsPageHandle(otherDocsPage - 1);
                          }}
                        >
                          <div>
                            <i class="fas fa-angle-left"></i>
                          </div>
                        </div>
                      </div>
                    )}
                    {otherDocs && otherDocs.length > 0 && (
                      <div className="pagin_cust docu position-absolute review-list-btn right-btn">
                        <div
                          className={`next  ${
                            !otherDocsData?.hasNextPage ? "disabled" : ""
                          }`}
                          onClick={() => {
                            _otherDocsPageHandle(otherDocsPage + 1);
                          }}
                        >
                          <div>
                            <i class="fas fa-angle-right"></i>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="file-list-rw d-flex overflow-auto">
                      {otherDocs?.map((doc) => {
                        return (
                          <div
                            className="list-col"
                            onClick={(e) => {
                              setDocumentInfo(doc);
                              handleDivClick(doc, e);
                            }}
                          >
                            <FileListBox
                              className={`success ${
                                doc?._id == selectedDocument ? "active" : ""
                              }`}
                              fileStatus={fileStatus}
                              selectedIconId={selectedIconId}
                              handleFavUnfavDoc={(status, id) => {
                                _favUnfavDoc(status, id, doc, "otherdocs");
                              }}
                              documentDetails={doc}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {otherLabeledDocsData?.docs?.length > 0 && (
                <div className="file-list-block">
                  <div className="head d-flex align-items-center">
                    Labeled Documents:{"  "}
                    {otherLabeledDocsData?.totalDocs}
                    <div className="current-view-count">
                      Showing {otherLabeledDocsStartingIndex}-
                      {!otherLabeledDocsData?.hasNextPage
                        ? otherLabeledDocsData?.totalDocs
                        : otherLabeledDocsEndingIndex}{" "}
                      Records out of {otherLabeledDocsData?.totalDocs}
                    </div>
                  </div>

                  <div
                    className="d-flex position-relative"
                    ref={fileListRef}
                    onScroll={handleScroll}
                  >
                    {otherLabeledDocsData?.docs &&
                      otherLabeledDocsData?.docs?.length > 0 && (
                        <div className="pagin_cust docu position-absolute review-list-btn left-btn">
                          <div
                            className={`prev ${
                              !otherLabeledDocsData?.hasPrevPage
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              _otherLabeledDocsPageHandle(
                                otherLabeledDocsPage - 1
                              );
                            }}
                          >
                            <div>
                              <i class="fas fa-angle-left"></i>
                            </div>
                          </div>
                        </div>
                      )}
                    {otherLabeledDocsData?.docs &&
                      otherLabeledDocsData?.docs?.length > 0 && (
                        <div className="pagin_cust docu position-absolute review-list-btn right-btn">
                          <div
                            className={`next  ${
                              !otherLabeledDocsData?.hasNextPage
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              _otherLabeledDocsPageHandle(
                                otherLabeledDocsPage + 1
                              );
                            }}
                          >
                            <div>
                              <i class="fas fa-angle-right"></i>
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="file-list-rw d-flex overflow-auto">
                      {otherLabeledDocsData?.docs?.map((doc) => {
                        return (
                          <div
                            className="list-col"
                            onClick={(e) => {
                              setDocumentInfo(doc);
                              handleDivClick(doc, e);
                            }}
                          >
                            <FileListBox
                              className={`success ${
                                doc?._id == selectedDocument ? "active" : ""
                              }`}
                              fileStatus={fileStatus}
                              selectedIconId={selectedIconId}
                              handleFavUnfavDoc={(status, id) => {
                                _favUnfavDoc(status, id, doc, "otherlabeleddocs");
                              }}
                              documentDetails={doc}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="inner-blc flex-fill overflow-auto position-relative">
              {noRecords ? <NoRecord /> : ""}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default FilesInfoWrappper;
